// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';


const PrivateRoute = () => {
    const { token } = useAuth();

    return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
